<script lang="ts">
  import type Chart from "chart.js";
  import ChartComponent from "@shared/svelte/Components/Chart.svelte";

  export let categoriesData = {};
  export let chartLabels = [];
  export let extraClasses: string;
  export let distributorReport = null;
  export let chartData = {};
  export let chartOptionOverrides = {};

  const getLabelValue = function (value: number) {
    return value ? value.toFixed(0) : 0;
  };

  const defaultChartLabels = distributorId => {
    chartLabels = [
      "Beer: $" + getLabelValue(categoriesData[distributorId].type1_total_spend),
      "Wine: $" + getLabelValue(categoriesData[distributorId].type2_total_spend),
      "Liquor: $" + getLabelValue(categoriesData[distributorId].type3_total_spend),
      "Other: $" + getLabelValue(categoriesData[distributorId].type4_total_spend),
    ];
    return chartLabels;
  };

  const setChartValues = distributorReport => {
    if (categoriesData[distributorReport.distributor_id]) {
      return {
        labels: defaultChartLabels(distributorReport.distributor_id),
        datasets: [
          {
            data: [
              categoriesData[distributorReport.distributor_id].type1_percentage,
              categoriesData[distributorReport.distributor_id].type2_percentage,
              categoriesData[distributorReport.distributor_id].type3_percentage,
              categoriesData[distributorReport.distributor_id].type4_percentage,
            ],
            backgroundColor: ["#002B48", "#406076", "#99AAB6", "#E5E9EC"],
          },
        ],
      };
    }
    return null;
  };

  $: if (distributorReport) {
    chartData = setChartValues(distributorReport);
  }

  let chartConfig: Chart.ChartConfiguration = {
    type: "doughnut",
    data: {
      labels: chartLabels,
      datasets: [],
    },
    options: {
      title: {
        display: true,
        text: "Categories",
      },
      cutoutPercentage: 80,
      responsive: true,
      legend: {
        display: true,
        position: "bottom",
      },
      animation: {
        animateRotate: true,
        animateScale: true,
        easing: "easeOutSine",
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return chartLabels[tooltipItem.index];
          },
        },
      },
      ...chartOptionOverrides,
    },
  };

</script>

<ChartComponent {chartConfig} {extraClasses} {chartData} />
